import * as React from 'react';
import { connect } from 'react-redux';

import { IDocument } from '../../infrastructure/interfaces';
import AdditionalInfoEditorForm from '../DocumentEditor/AdditionalInfoForm/AdditionalInfoEditorForm';
import {
  changeAdditionalInfo,
} from '../../actions/actions';
import { productType } from '../../infrastructure/ProductType';

export interface IAdditionalTextProps {
  document: IDocument;
  changeAdditionalInfo(text: string | boolean, field: string): void;
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    changeAdditionalInfo: (text: string | boolean, field: string) => {
      dispatch(changeAdditionalInfo(text, field));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class IAdditionalTextChoosing extends React.Component<any, any> {

  onFieldChange = (value: string | boolean, field: string) => {
    this.props.changeAdditionalInfo(value, field);
  }

  modalPrompt() {
    if (this.props.document.type === productType.Postcard){
      return "Enter an optional message for the back of the postcard:"
    } if (this.props.document.type === productType.Poster) {
      return "Please enter the poster title:"
    } else {
      return "Enter subheadline for front cover:"
    }
  }

  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            {this.modalPrompt()}
          </div>
          <div className="stepMessage2">
            You can change this selection later
          </div>
        </div>
        <div className="additional-container">
          <AdditionalInfoEditorForm
            document={this.props.document}
            onFieldChange={this.onFieldChange}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Steps/AdditionalTextChoosing.tsx